import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

function ApprovalSchoolRegistrationComponent() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-12 items-center w-[886px] h-[367px] mobile:w-[345px] mobile:h-[328px]">
      <img
        src="/assets/images/message.svg"
        alt=""
        className="w-[180px] h-[180px] mobile:w-32 mobile:h-32"
      />
      <p className="font-arMedium text-2xl mobile:text-base text-black text-center">
        {t("approvalSchoolRegistatraion.component.approved")}
      </p>
      <button
        className="w-[345px] h-14 px-4 py-2 bg-mint-500 text-white text-xl font-arMedium rounded-xl"
        onClick={() => navigate(appRoutesObj.getBasePath())}
      >
        {t("approvalSchoolRegistatraion.component.homepage")}
      </button>
    </div>
  );
}

export default ApprovalSchoolRegistrationComponent;
